<template>
  <div
    v-if="anchorList.length"
    class="demolist-anchor-container"
  >
    <ul
      v-for="anchor in anchorList"
      :key="anchor.id"
      class="anchor-list"
    >
      <li class="anchor-title">
        {{ anchor.name }}
      </li>
      <li
        v-for="item in anchor.children"
        :key="item.id"
        class="anchor-list-item"
        :class="{'is-active': activeIndex === item.name}"
      >
        <a
          @click="onChangeAnchor(item.name)"
        >{{ item.name }}</a>
      </li>
    </ul>
  </div>
</template>
<script>
import throttle from 'lodash/throttle';

const waitTime = 100;

export default {
  name: 'DemoListAnchor',
  props: {
    anchorList: {
      type: Array,
      default: () => [],
    },
    categoryPositions: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      scroll: 0,
      activeIndex: '',
      isClick: false,
      anchorActive: 0,
      throttleScrollHandler: null,
    };
  },
  mounted() {
    this.throttleScrollHandler = throttle(this.onScroll, waitTime);
    window.addEventListener('scroll', this.throttleScrollHandler, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.throttleScrollHandler);
  },
  methods: {
    onScroll(e) {
      if (this.isClick) {
        return;
      }
      const targetId = e.target.id;
      if (!targetId) {
        return;
      }
      const currentOffsetTop = document.getElementById(targetId).scrollTop;
      const { categoryPositions } = this;
      const len = categoryPositions.length;
      for (let i = 0; i < len - 1; i++) {
        if (currentOffsetTop >= categoryPositions[i].height && currentOffsetTop < categoryPositions[i + 1].height) {
          this.activeIndex = categoryPositions[i].name;
          break;
        }
      }
    },
    onChangeAnchor(id) {
      if (this.activeIndex === id) {
        return;
      }
      const dom = document.getElementById(id);
      // console.log('dom: ', dom);
      if (!dom) {
        return;
      }
      this.isClick = true;
      dom.scrollIntoView({ ehavior: 'smooth' });
      this.$router.replace({ path: `${this.$route.path}#${id}` });
      this.activeIndex = id;
      this.timer = setTimeout(() => {
        this.isClick = false;
        clearTimeout(this.timer);
      }, waitTime);
    },
  },
};
</script>
<style lang="less">
.demolist-anchor-container {
  width: 150px;
  .anchor-list {
    overflow: auto;
    padding: 0;
    &::-webkit-scrollbar {
      display: none;
    }
    .anchor-title {
      padding: 25px 0 8px 18px;
      font-size: 12px;
      color: #757575;
      line-height: 18px;
      list-style: none;
      border-left: 2px solid #E6EAF4;
    }
    &-item {
      list-style: none;
      a {
        cursor: pointer;
        display: block;
        font-size: 14px;
        color: #10131F;
        line-height: 24px;
        padding: 10px 0 10px 18px;
        border-left: 2px solid #E6EAF4;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &.is-active {
        a {
          border-color: #295BFF;
          color: #295BFF;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
